module.exports = __webpack_public_path__ + "static/media/Tackling_4.12fa9490.png";